export async function validateMovieForm(form) {

    let valid = true;
    let message = 'valid';

    const movie_synopsis = form.movie_synopsis;
    const movie_material = form.material_digital_arry;

    if (Array.isArray(movie_synopsis) && movie_synopsis.length) {
        for (const ms of movie_synopsis) {
            if(ms.synopsis_short && ms.synopsis_short.length > 10000) {
                return {
                    valid: false,
                    message: `Short Synopsis Character count cannot be greater than 10000`
                }
            }
            if(ms.synopsis_long && ms.synopsis_long.length > 65000) {
                return {
                    valid: false,
                    message: `Long Synopsis Character count cannot be greater than 65000`
                }
            }
        }
    }
    if (Array.isArray(movie_material) && movie_material.length) {
        for(const mm of movie_material){
            if((!mm.material_language_version || mm.material_language_version.length === 0)){
                return {
                    valid: false,
                    message: `For material, the Languages field cannot be empty.`
                }
            }
        }
    }

    return {
        valid,
        message
    }
}